import { Component, input, computed} from '@angular/core';
import { CommonModule } from '@angular/common';
import { KENDO_LABELS } from "@progress/kendo-angular-label";
import { KENDO_TEXTBOX, KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { IVesselStop, IVesselMovement, selectEditingVesselActivities } from '@pmis3/vessel-activity-core';
import { IconsModule } from '@progress/kendo-angular-icons';
import { AppUtils } from '@pmis3/core';
import { VesselStopTypeForStepper } from '@pmis3/vessel-activity-core';
import { VesselActivityHelper } from '@pmis3/vessel-activity-core';
import { Store } from '@ngrx/store';
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { KENDO_COMBOBOX } from "@progress/kendo-angular-dropdowns";
import { KENDO_DATEINPUTS } from '@progress/kendo-angular-dateinputs';

@Component({
    selector: 'pmis3-vessel-visit-stepper-stop-summary',
    standalone: true,
    imports: [CommonModule, KENDO_LABELS, KENDO_TEXTBOX, KENDO_INPUTS, IconsModule, KENDO_BUTTONS, KENDO_COMBOBOX, KENDO_DATEINPUTS],
    templateUrl: 'vessel-visit-stepper-stop-summary.component.html',
    styleUrl: 'vessel-visit-stepper-stop-summary.component.scss'
})
export class VesselVisitStepperStopSummaryComponent {
    stopIndex = input.required<number>();
    vesselMovement = input.required<IVesselMovement>();
    vesselStop = input.required<IVesselStop>();
    stopType = input.required<VesselStopTypeForStepper>();
    stopNumber = input.required<number>();
    inEditMode = input.required<boolean>();

    vesselActivities = this.store.selectSignal(selectEditingVesselActivities);

    previousStop = computed(() => {
        if (!this.inEditMode()) return null;

        const vesselActivities = this.vesselActivities() ?? [];
        const arrivalMovementIndex = this.stopIndex() - 1 >= 0 ? this.stopIndex() - 1 : null
        if (arrivalMovementIndex == null) return null;
        return VesselActivityHelper.getPreviousVesselActivity(vesselActivities, arrivalMovementIndex);
    })
    departureMovement = computed(() => {
        if (!this.inEditMode()) return null;

        const vesselActivities = this.vesselActivities() ?? []
        const depMovementIndex = this.stopIndex() + 1 < vesselActivities.length ? this.stopIndex() + 1 : null;
        return depMovementIndex != null ? VesselActivityHelper.getPreviousVesselActivity(vesselActivities, depMovementIndex) : null;
    })

    ataExists = computed(() => !!this.vesselMovement()?.endTime);
    atdExists = computed(() => !!this.vesselStop()?.endTime);

    startTimeIsValid = computed(() => !this.inEditMode() || VesselActivityHelper.activityEndTimeIsValid(this.vesselMovement(), this.previousStop(), this.vesselStop(), this.ataExists() ));
    endTimeIsValid = computed(() => !this.inEditMode() || VesselActivityHelper.activityEndTimeIsValid(this.vesselStop(), this.vesselMovement(), this.departureMovement(), this.atdExists()));

    startTimeLabel = computed(() => this.ataExists() ? 'ATA' : 'ETA');
    endTimeLabel = computed(() => this.atdExists() ? 'ATD' : 'ETD');
    startTimeDate = computed(() => this.vesselMovement() ? AppUtils.DateTime.GetDateString(VesselActivityHelper.getTimeForActivity(this.vesselMovement())) : "");
    startTimeTime = computed(() => this.vesselMovement() ? AppUtils.DateTime.GetTimeString(VesselActivityHelper.getTimeForActivity(this.vesselMovement())) : "")
    endTimeDate = computed(() => this.vesselStop() ? AppUtils.DateTime.GetDateString(VesselActivityHelper.getTimeForActivity(this.vesselStop())) : "");
    endTimeTime = computed(() => this.vesselStop() ? AppUtils.DateTime.GetTimeString(VesselActivityHelper.getTimeForActivity(this.vesselStop())) : "")

    constructor(private store: Store<any>) { }
}
